import { Injectable } from '@angular/core';
import { LocalStorageProps } from '@commoncore/enums/localStorageProps';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { USER_DETAILS } from '@mainrepo/app/core/constants/Constants';
import { SyncStorageHandler } from '@mainrepo/app/core/database/SyncStorageManager';
import { SessionStorageProps } from '../enums/sessionStorageProps';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {

    syncStorageHandler: SyncStorageHandler;
    constructor(

    ) {
      this.syncStorageHandler = new SyncStorageHandler();
    }

    private setSessionItem(key, value, toEncrypt: boolean = false) {
      if (toEncrypt) {
        this.syncStorageHandler.setSessionProperty(key, value)
      } else {
        sessionStorage.setItem(key, value)
      } 
    }
  
    private getSessionItem(key, isEncrypted: boolean = false) {
      
      if (isEncrypted) {
        return this.syncStorageHandler.getSessionProperty(key)
      } else {
        return sessionStorage.getItem(key)
      } 
    }


    public getShareKey(toEncrypt?:boolean){
      return this.getSessionItem(SessionStorageProps.SHARE_KEY, true);
    }

    public setShareKey(object,toEncrypt?){
      this.setSessionItem(SessionStorageProps.SHARE_KEY, object, toEncrypt);
    }

    public getSingleSharedObject(object,toEncrypt?:boolean){
      return ((this.getSessionItem(SessionStorageProps.SINGLE_SHARED_OBJECT, true) != undefined && this.getSessionItem(SessionStorageProps.SINGLE_SHARED_OBJECT, true) != null) ? this.getSessionItem(SessionStorageProps.SINGLE_SHARED_OBJECT, true) : "");
    }

    public setSingleSharedObject(object,toEncrypt?){
      this.setSessionItem(SessionStorageProps.SINGLE_SHARED_OBJECT, object, toEncrypt);
    }

    public setGrantAccessId(object,toEncrypt?:boolean){
      return this.setSessionItem(SessionStorageProps.GRANT_ACCESS_ID, object, toEncrypt);
    }

    public getGrantAccessId(toEncrypt?:boolean){
      return this.getSessionItem(SessionStorageProps.GRANT_ACCESS_ID, true);
    }

    public removeSessionProperty(property){ 
      sessionStorage.removeItem(property);
    }

    public setBuyStorageAlreadyInitiated(data){
      this.setSessionItem(SessionStorageProps.BUY_STORAGE_INITIATED,data,false);
    }
  
    public getBuyStorageAlreadyInitiated(){
      return this.getSessionItem(SessionStorageProps.BUY_STORAGE_INITIATED,false);
    }

    public setObjectWithExpiry(key, value){
      // return this.setSessionItem(,true, false);
      //let key = SessionStorageProps.BUY_STORAGE
      var currentTime = new Date().getTime();
      const item = {
        value: value,
        expiry: currentTime + (ENV_CONSTANTS["constants"]["localStorageKeysExpiryTime"]*60000),
      }
      sessionStorage.setItem(key, JSON.stringify(item))
    }

    public getObjectWithExpiry(key){
      // return this.getSessionItem(SessionStorageProps.BUY_STORAGE, false);
      //let key = SessionStorageProps.BUY_STORAGE
      const itemStr = sessionStorage.getItem(key)
      if (!itemStr) {
        return ""
      }
      const item = JSON.parse(itemStr)
      const now = new Date().getTime();
      if (now > item.expiry) {
        sessionStorage.removeItem(key)
        return ""
      }
      return item.value
    }

    public setShowToastAlbumEntUser(data){
      this.setSessionItem(SessionStorageProps.SHOW_TOAST_ALBUM_ENT_USER,data,false);
    }
  
    public getShowToastAlbumEntUser(){
      return this.getSessionItem(SessionStorageProps.SHOW_TOAST_ALBUM_ENT_USER,false);
    }

    public setPrivateFolderPasswordTime(data){
      this.setSessionItem(SessionStorageProps.PRIVATE_FOLDER_PASSWORD_TIME,data,false);
    }
  
    public getPrivateFolderPasswordTime(){
      return this.getSessionItem(SessionStorageProps.PRIVATE_FOLDER_PASSWORD_TIME,false);
    }

    public getBreadCrumbsList(isEncrypted:boolean = false) {
      return this.getSessionItem(SessionStorageProps.BREADCRUMBS,isEncrypted);
    }

    public setBreadCrumbsList(val, toEncrypt:boolean = false) {
        this.setSessionItem(SessionStorageProps.BREADCRUMBS, val, toEncrypt);
    }

    public setCurrentTabName(tabName){
      this.setSessionItem(SessionStorageProps.CURRENT_TAB_NAME, tabName)
    }

    public getCurrentTabName(){
      return this.getSessionItem(SessionStorageProps.CURRENT_TAB_NAME);
    }

    public setUnivShareLinkSessionID(id){
    this.setSessionItem(SessionStorageProps.UNIV_SHARELINK_SESSION_ID,id,false);
  }
    public getCurrentFolderkey(isEncrypted?:boolean){
      return this.getSessionItem(SessionStorageProps.CURRENT_FOLDER_KEY, isEncrypted) ;
    }

    public setCurrentFolderKey(currentKey, toEncrypt?){
      const rootFolderKey = USER_DETAILS["USER_DETAILS"]["rootFolderKey"] ? USER_DETAILS["USER_DETAILS"]["rootFolderKey"] : null;
      if(currentKey && currentKey != rootFolderKey){
        this.setSessionItem(SessionStorageProps.CURRENT_FOLDER_KEY, currentKey, toEncrypt);
      } else {
        this.setSessionItem(SessionStorageProps.CURRENT_FOLDER_KEY, null, toEncrypt);
      }
      
    }

    

  public getUnivShareLinkSessionID(){
    return this.getSessionItem(SessionStorageProps.UNIV_SHARELINK_SESSION_ID,false);
  }

  public removeUnivShareLinkSessionID(){
    this.removeSessionProperty(SessionStorageProps.UNIV_SHARELINK_SESSION_ID)
  }

  public setUnivShareLinkPswd(pswd){
    this.setSessionItem(SessionStorageProps.UNIV_SHARELINK_PASSWD,pswd,true);
  }

  public getUnivShareLinkPswd(){
    return this.getSessionItem(SessionStorageProps.UNIV_SHARELINK_PASSWD,true);
  }

  public removeUnivShareLinkPswd(){
    this.removeSessionProperty(SessionStorageProps.UNIV_SHARELINK_PASSWD)
  }

  public setUnivShareLinkShareKey(key){
    this.setSessionItem(SessionStorageProps.UNIV_SHARELINK_SHAREKEY,key,false);
  }

  public getUnivShareLinkShareKey(){
    return this.getSessionItem(SessionStorageProps.UNIV_SHARELINK_SHAREKEY,false);
  }

  public removeUnivShareLinkShareKey(){
    this.removeSessionProperty(SessionStorageProps.UNIV_SHARELINK_SHAREKEY)
  }

  public setShareLinkCreator(id){
    this.setSessionItem(SessionStorageProps.PUBLIC_LINK_CREATOR,id,false);
  }

  public getShareLinkCreator(){
    return this.getSessionItem(SessionStorageProps.PUBLIC_LINK_CREATOR,false);
  }

  public getuserCookieExist(){
    return this.getSessionItem(SessionStorageProps.USER_COOKIE_EXIST, false);
  }

  public setUserCookieExist(object){
    this.setSessionItem(SessionStorageProps.USER_COOKIE_EXIST, object, false);
  }
    public setCurrentPrivateFolderKey(currentKey, toEncrypt?){ 
      const privateFolderRootKey = localStorage.getItem(LocalStorageProps.PRIVATE_FOLDER_KEY)
      if(currentKey && currentKey != privateFolderRootKey){
        this.setSessionItem(SessionStorageProps.CURRENT_PRIVATE_FOLDER_KEY, currentKey, false);
      } else {
        this.setSessionItem(SessionStorageProps.CURRENT_PRIVATE_FOLDER_KEY, privateFolderRootKey, false);
      }
    }
  
    public getCurrentPrivateFolderKey(isEncrypted?:boolean){
      return this.getSessionItem(SessionStorageProps.CURRENT_PRIVATE_FOLDER_KEY, false) ;
    }

    
  public setSharePublicSortPropName(name){
    this.setSessionItem(SessionStorageProps.SORT_PROP_NAME, name)
  }

  public getSharePublicSortPropName(){
    return this.getSessionItem(SessionStorageProps.SORT_PROP_NAME);
  }

  public setListViewSortOrder(listOrder){
    this.setSessionItem(SessionStorageProps.SORT_LIST_ORDER, listOrder)
  }

  public getListViewSortOrder(){
    return this.getSessionItem(SessionStorageProps.SORT_LIST_ORDER);
  }
  public removeListViewSortOrder(){
    this.removeSessionProperty(SessionStorageProps.SORT_LIST_ORDER)
  }

  public setCurrentTeamFolder(currentTF){
    this.setSessionItem(SessionStorageProps.CURRENT_TEAM_FOLDER,currentTF,true);
  }

  public getCurrentTeamFolder(){
    return this.getSessionItem(SessionStorageProps.CURRENT_TEAM_FOLDER,true);
  }

  public setNestedTeamFolderkey(folderKey){
    this.setSessionItem(SessionStorageProps.NESTED_TEAM_FOLDER_KEY,folderKey,true);
  }

  public getNestedTeamFolderkey(){
    return this.getSessionItem(SessionStorageProps.NESTED_TEAM_FOLDER_KEY,true);
  }


  getSessionProperty(key,isEncrypted?:boolean){
    return this.getSessionItem(key, isEncrypted) ;
  }

  setSessionProperty(key,value,isEncrypted?:boolean){
    return this.setSessionItem(key,value, isEncrypted) ;
  }


  
  
}
